import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { type WorkBadgeReviewPolicySource } from "../../WorkBadges/components/Policy/types";
import { useWorkerWorkBadgesMaxUi } from "../../WorkBadges/hooks/useWorkerWorkBadgesMaxUi";
import { getWorkBadgeReviewPolicyUrl } from "../../WorkBadges/utils/getWorkBadgeReviewPolicyUrl";
import { BaseIndependentContractorBadgeRequiredCard } from "./BaseIndependentContractorBadgeRequiredCard";
import { BaseWorkBadgeRequiredCard } from "./BaseWorkBadgeRequiredCard";

interface BaseWorkBadgeRequiredCardContainerProps {
  analyticsMetadata: Record<string, string | boolean | undefined>;
  source: WorkBadgeReviewPolicySource;
  shiftId: string;
  qualification: string;

  // Props for legacy card
  state: string;
}

export function BaseWorkBadgeRequiredCardContainer(props: BaseWorkBadgeRequiredCardContainerProps) {
  const { analyticsMetadata, source, shiftId, qualification, state } = props;

  const history = useHistory();
  const { enabled: isWorkBadgesMaxUiEnabled } = useWorkerWorkBadgesMaxUi();

  const handleReviewPolicy = useCallback(() => {
    history.replace(
      getWorkBadgeReviewPolicyUrl({
        source,
        shiftId,
        qualificationName: qualification,
      })
    );
  }, [history, source, shiftId, qualification]);

  if (isWorkBadgesMaxUiEnabled) {
    return (
      <BaseWorkBadgeRequiredCard
        analyticsMetadata={analyticsMetadata}
        onReviewPolicy={handleReviewPolicy}
      />
    );
  }

  return (
    <BaseIndependentContractorBadgeRequiredCard
      history={history}
      shiftId={shiftId}
      state={state}
      qualification={qualification}
      analyticsMetadata={analyticsMetadata}
    />
  );
}
